'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    shipping = require('./shipping.js'),
    dynamicAddress = require('../dynamic-address'),
    progress = require('../../progress'),
    bornModules = require('../../helpers/born.modules').default,
    addressUtil = require('../../helpers/address.utils'),
    _ = require('lodash');

import {breakpoints,readCookie} from '../../helpers/born.utils';

var isFormElFound = false;
var addressToEdit = null;

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="cardPaymentForm_owner"]').val(data.holder).trigger('change');
    $creditCard.find('input[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_cardPaymentForm_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name*="cardPaymentForm_cvn"]').val('').trigger('change');
    formPrepare.validateForm();
}

function cleanCardForm() {
    var $creditCard = $('[data-method="CREDIT_CARD"]').trigger('change');
    $creditCard.find('input[name$="cardPaymentForm_owner"]').val('').trigger('change');
    $creditCard.find('input[name*="_cardPaymentForm_number"]').val('').trigger('change');
    $creditCard.find('[name$="_cardPaymentForm_expiration_month"]').val('').trigger('change');
    $creditCard.find('[name$="_year"]').val('').trigger('change');
    
    if( $('#dw_cardTypeDone').length > 0){
        $('#dw_cardTypeDone').find('img').hide();
        $('#default_thumb').show();
    }
    $creditCard.find('[id$="cardPaymentForm_type"]').val('');
    $creditCard.find('[name$="_saveCard"]')[0].checked = false;
    $creditCard.find('input[name$="cardPaymentForm_cardToken"]').val('');
    if($('.cvn input[name*="cardPaymentForm_cvn"]').length <=0) {
        $('input[name*="cardPaymentForm_cvn"]').removeClass('error').insertAfter('.cvn .field-wrapper label');
    }
    $creditCard.find('input[name*="cardPaymentForm_cvn"]').val('').trigger('change');
    formPrepare.validateForm();
}

function cleanAddressForm() {
    $('input[name$="_firstName"]').val('');
    $('input[name$="_lastName"]').val('');
    $('input[name$="_phone"]').val('');
    $('input[name$="_address1"]').val('');
    $('input[name$="_address2"]').val('');
    $('input[name$="_address3"]').val('');
    $('input[name$="_postal"]').val('');
    var countryEl = $('[name$="_country"]');
    if(countryEl && countryEl.length > 0) {
    	if(countryEl.val() == 'kw' && !addressUtil.isDependentAddress()) {
    		return;
    	}
    }
    $('input[name$="_city"]').val('');
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            setCCFields(data);
        }
    });
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
    $paymentMethods.removeClass('payment-method-expanded');

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
    if ($selectedPaymentMethod.length === 0) {
        // Select the active method if it is present in template
        $selectedPaymentMethod = $('[data-method="CustomObject"], [data-method="Custom"]');
    }
    $selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('.payment-method-options').val() != paymentMethodID &&
        $('.payment-method-options').val(paymentMethodID).change().selectric('refresh');

    if (paymentMethodID == 'CHECKOUTCOM_APM') {
        resetAPMPaymentMethod();
    }
    
    if (paymentMethodID === 'CHECKOUTCOM_APPLE_PAY' && window.innerWidth >= 768) {
        $('#submit-order').addClass('hidden');
        $('.billing-address-form-wrapper').addClass('hidden');
    }else{
        $('#submit-order').removeClass('hidden');
        $('.billing-address-form-wrapper').removeClass('hidden');
    }
    if (paymentMethodID === 'CHECKOUTCOM_APPLE_PAY' && window.innerWidth < 768) {
        $('#ckoApplePayButton').addClass('apple-pay-button-checkout-hidden');
        $('#submit-order').addClass('hidden');
        $('.billing-address-form-wrapper').addClass('hidden');
        $('#applePayDummyBtn').removeClass('hidden').on('click.triggerApplePay', () => {
            $('#ckoApplePayButton').trigger('click');
        })
    } else if ($('.apple-pay-button-checkout-hidden').length) {
        $('#ckoApplePayButton').removeClass('apple-pay-button-checkout-hidden');
        $('#submit-order').removeClass('hidden');
        $('.billing-address-form-wrapper').removeClass('hidden')
        $('#applePayDummyBtn').addClass('hidden').off('click.triggerApplePay')
    }
    formPrepare.validateForm();
    
    if(paymentMethodID === 'DW_COD') {
        $(document).trigger('checkformbutton');
    }
}

function getBEErrorEl($field) {
    return $field.find('.error-message').length ? $field.find('.error-message') : $('<p class="form-caption error-message"></p>').insertAfter($field.find('input'))
}
/**
 * Stores form data for later usage on page refresh.
 * @param  {[type]} $form [description]
 * @return {[type]}       [description]
 */
function storeShippingFormData($form) {
    window.sessionStorage.setItem('shippingFormData', JSON.stringify($form.serializeArray()));
}




function processPromoEntry(e, options, param, page) {
    e.preventDefault();
    
    if(page === undefined) {
        page = 'billing';
    }
    
    var $promoField;
    if(param == 'coupon' || page == 'shipping') {
         $promoField = $('.order__summary__coupon');
    } else {
        $promoField = $('.order--checkout__' + options.type);
    }

    if(param=== 'coupon' && $('.is-guest-user').length > 0){
        var $closestShippingForm = $('[id$="singleshipping_shippingAddress"]');
        storeShippingFormData($closestShippingForm);
    }
    
    var $error = getBEErrorEl($promoField);

    if (options.code.length === 0) {
        $promoField.addClass('error');
        $error.html(options.missingError);

        return;
    }

    var url = util.appendParamsToUrl(options.controller, options.params);

    $.getJSON(url, function (data) {
        var fail = false;
        var msg = '';
        var dataMsg;

        if (!data) {
            msg = Resources.BAD_RESPONSE;
            fail = true;
        }

        else if (!data.success) {
            dataMsg = ('alreadyAppliedMsg' in data && data.alreadyAppliedMsg) ? data.alreadyAppliedMsg : data.message;
            msg = dataMsg.split('<').join('&lt;').split('>').join('&gt;');
            fail = true;
        }
        var user = dataLayer.find(o => o.user != null).user;
        if (fail) {
            $promoField.addClass('error');
            $error.html(msg);
            if(param === "coupon" &&  options.operation==='addCoupon'){
                var hasData = dataLayer.find(o => o.bag != null) != null;
                var basketID;
                if(hasData){
                    var bag = dataLayer.find(o => o.bag != null).bag;
   		            basketID = bag.id;
                }
                var coupon =  {
				 "country":data.country,
				 "language":data.language,
				 "appAzadea_platform":appAzadea_platform,
				 "coupon_code":data.CouponCode,
				 "cart_id":basketID
				};
				dataLayer.push({'apply_coupon_code_failed' : coupon});
				dataLayer.push({'event':'moengageGoToBagEvent'});
				
		        dataLayer.push({
		            'event': 'custom_event',
		            'eventCategory': 'checkout_page',
		            'eventAction': 'checkout_apply_code',
		            'eventLabel': 'checkout apply code click - Invalid',// Valid or Invalid    
		            'coupon': data.CouponCode,
		    	    'country': window.GlobalAttributes.COUNTRY,
		    	    'language': window.GlobalAttributes.LANGUAGE,
		    	    'screenName' : 'Checkout Page',
		    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
		    	    'userId': user.user_id != '' ? user.user_id : ''
		        });
            }
            if (param == 'giftcert') {
                dataLayer.push({
                    'event': 'custom_event',
                    'eventCategory': 'checkout_page',
                    'eventAction': 'checkout_redeem_gift_card_failed',
                    'eventLabel': 'checkout redeem gift card failed',
                    'country': window.GlobalAttributes.COUNTRY,
                    'language': window.GlobalAttributes.LANGUAGE,
                    'screenName' : 'Checkout Page',
                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                    'userId': user.user_id != '' ? user.user_id : ''
                });
            }
            return;
        }

        if (data.success) {
            //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
            //this will force a page refresh to display the coupon message based on a parameter message	
            // if( data.baskettotal <= 0 || !data.baskettotal) {
            var $closestForm = $promoField.closest('form');
            if(param !== "giftcert" && param !== "coupon"){
                storeFormData($closestForm);
            }
            
         	if (param == 'giftcert') {
                dataLayer.push({
                    'event': 'custom_event',
                    'eventCategory': 'checkout_page',
                    'eventAction': 'checkout_redeem_gift_card_success',
                    'eventLabel': 'checkout redeem gift card success',
                    'country': window.GlobalAttributes.COUNTRY,
                    'language': window.GlobalAttributes.LANGUAGE,
                    'screenName' : 'Checkout Page',
                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                    'userId': user.user_id != '' ? user.user_id : ''
                });
         	}
         	
         	if ( param == "coupon") {
    	        dataLayer.push({
    	            'event': 'custom_event',
    	            'eventCategory': 'checkout_page',
    	            'eventAction': 'checkout_apply_code',
    	            'eventLabel': 'checkout apply code click - Valid',// Valid or Invalid    
    	            'coupon': data.CouponCode,
    	    	    'country': window.GlobalAttributes.COUNTRY,
    	    	    'language': window.GlobalAttributes.LANGUAGE,
    	    	    'screenName' : 'Checkout Page',
    	    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    	    'userId': user.user_id != '' ? user.user_id : ''
    	        });
         	}
            
            if(param == "giftcert" || param == "coupon") {
                if(param == "coupon"){
                    localStorage.setItem("isCouponApplied", true);
                }
                setPromoSession(param);
            }
            
            //to handle 3ds back
            if(SitePreferences.IS_3DS_ENABLED  && (param == "giftcert" || param == "coupon") && page == 'billing'){
            	var url = util.appendParamToURL(Urls.billing).split("?")[0];
            	window.location.assign(url);
            }else if((param == "giftcert" || param == "coupon") && page == 'billing'){
            	var url = util.appendParamToURL(Urls.billing).split("?")[0];
            	window.location.assign(url);
            } else if(param == "coupon" && page == 'shipping'){
            	var url = Urls.shipping;
            	window.location.assign(url);
            }else{
            	window.location.assign($closestForm.attr('action'));
            }
            if(param === "coupon" && (options.operation==='addCoupon' || options.operation==='removeCoupon')){
                var hasData = dataLayer.find(o => o.bag != null) != null;
                var basketID;
                if(hasData){
                    var bag = dataLayer.find(o => o.bag != null).bag;
   		            basketID = bag.id;
                }
                var coupon =  {
				 "country":data.country,
				 "language":data.language,
				 "appAzadea_platform":appAzadea_platform,
				 "coupon_code":data.CouponCode,
				 "cart_id":basketID
				};
				if(options.operation==='addCoupon'){
				    dataLayer.push({'apply_coupon_code' : coupon});
				} else if(options.operation==='removeCoupon'){
				    dataLayer.push({'remove_coupon_code' : coupon});
				}
				
				dataLayer.push({'event':'moengageGoToBagEvent'});
            }
            
            
        }

        // $('.order--checkout__'+ options.type +'__msgs').append(data.message + '<br />');

        // shipping.updateSummary();
    });
}

/**
 * Stores form data for later usage on page refresh.
 * @param  {[type]} $form [description]
 * @return {[type]}       [description]
 */
function storeFormData($form) {
    window.sessionStorage.setItem('billingFormData', JSON.stringify($form.serializeArray()));
}

/**
 * Sets form data if available on the sessionStorage object, then clears it.
 * @return {[type]} [description]
 */
function resetFormData() {
    var parsedData = JSON.parse(window.sessionStorage.getItem('billingFormData')),
        billingFieldID = 'billingAddress_addressFields',
    	billingSaveToggleField = 'saveBillingAddress',
    	addToAddressID = 'addToAddressBook',
        addressList = 'addressList'
    if (!parsedData) {
        return;
    }
    
    /*reset all checked address*/
    $('input[id$="_addToAddressBook"]:checked').prop('checked', false);
 
    parsedData.forEach(function (storedField) {
        if (storedField.name.indexOf(billingFieldID) !== -1 || storedField.name.indexOf(billingSaveToggleField) !== -1 || storedField.name.indexOf(addToAddressID) !== -1) {
            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');

            if(fieldEl !==undefined && fieldEl !=null){
                fieldEl.value = storedField.value;
                if (fieldEl.nodeName === 'SELECT') {
                    $(fieldEl).trigger('change');
                }
                if(storedField.name.indexOf(addToAddressID) !== -1 && storedField.value == 'true') {
                    $('input[id$="_addToAddressBook"]').prop('checked', true);
                } 
                $(fieldEl).trigger('change');
            }
        }
        if(storedField.name.indexOf(addressList) !== -1){
            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');
            $('input[name="' + fieldEl.name+ '"][value="' + storedField.value + '"]').prop('checked', true);
        }
    });

    window.sessionStorage.removeItem('billingFormData');
}

function disableButtonAfterSubmit() {
    const $form = $('.checkout-billing');

    $form.on('submit', function () {
        $('#submit-order').attr('disabled', true);
    });
}

function detectEditChanges() {
    var $form = $('.address');

    $('.js-us-different-address ')
        .on('click', function () {
            $form.find('[id$="_editAddressBook"]').prop('checked', false);
            $form.find('[id$="_unsavedAddressBook"]').prop('checked', true);
            
        });
        
        $('.js-us-saved-address')
        .on('click', function () {
            $form.find('[id$="_editAddressBook"]').prop('checked', false);
            $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
        });

    $('.js-edit').on('click', function () {
        $form.find('[id$="_editAddressBook"]').prop('checked', true);
        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
        addressUtil.initGovernateEvents();
        addressUtil.updateGovernateInfo();
        addressToEdit = $(this).parent();
        $('.custom-address').removeClass('hidden');
        $('.js-use-different').addClass('hidden');
        scrollHere($('.js-address').first());
    });
}

// Detect phone changes for the validator-check in formPrepare
function detectPhoneChanges() {
    var $dummyPhoneField = $('input[name$=_addressFields_phone--dummy]');
    var $phoneField = $('input[name$=_addressFields_phone]');
    $phoneField.val($dummyPhoneField.val());

    $dummyPhoneField.on('change', function () {
        $phoneField.val($dummyPhoneField.val());
    })
}

//Toggle Use Saved Card or Use Different Card
function resetUseSavedCardOrDifferentCard(){
    var $errorForm = $('.order--checkout__ccmethod').find('.error-message');
	if(!$('.order--checkout__ccmethod').hasClass('toggle--active')){
		if ($.trim($errorForm.html())!='' && $('.billing-error').length <=0) {
			if ($("span").hasClass('js-reset-validation')&& $("span").hasClass('js-clean-form')) {
				$('.order--checkout__ccmethod').addClass('toggle--active');
				$('.form-row.cta.cta--underlined.txt--upper').addClass('toggle--active');
				$('.order--checkout__ccnew').addClass('toggle--active');
			} 
		}
	}
    if($('.billing-error').length > 0 && $.trim($('.billing-error').html())!=''){
        $('.required.error').removeClass('error');
        $errorForm.remove();
    }
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.val();
    var $usedASavedCardClean = $('.js-clean-form');
    var $resetValidation = $('.js-reset-validation');
    var $unclickAddress = $('.js-use-different');
    var $errorForm = $('.order--checkout__ccmethod').find('.error-form');
    var $deleteCoupon = $('.remove-coupon');
    
    var billingFields = addressUtil.getAddressFields();
    //$('.address').on('change', billingFields, formPrepare.validateForm);
    
    resetFormData();
    formPrepare.validateForm();
    resetUseSavedCardOrDifferentCard();
    
    
    dynamicAddress.init('.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm);


    formPrepare.init({
        formSelector: 'form[id$="billing"]',
        continueSelector: '[name$="billing_save"]'
    });
    // Refill billing form with default data if customer decides to use saved address
    $('.js-us-saved-address')
        .on('click', function () {
            const $form = $('.address');
            var selectedAddress = $('input[name$="_addressList"]:checked').data('address');
            $('input[name$="_saveBillingAddress"]').val(0);
            if (selectedAddress) {
                util.fillAddressFields(selectedAddress, $form);
            } else {
                cleanAddressForm();
                formPrepare.validateForm();
            }
            $form.find('input[name$="_addressList"]').prop('checked', false);
            $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
            formPrepare.validateForm();
        });

    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD');
    $('.payment-method-options').on('change', function () {
        const paymentMethod = $(this).val();
        if (paymentMethod === 'PayPal') {
            $('input[name$="_paypalIsChecked"]').prop('checked', true);
            $('input[name$="_paypalIsChecked"]').val('true');
            progress.show();
            $('.converted').removeAttr('hidden');
            setTimeout(() => {
                progress.hide();
            }, 300);
        } else if (paymentMethod == 'CHECKOUTCOM_APM') {
            resetAPMPaymentMethod();
        } else {
           resetPaymentMethods();
        }
        if($('.knet-error-details').length > 0){
            $('.knet-error-details').empty();
        }
        updatePaymentMethod($(this).val());
        if(paymentMethod === 'DW_COD') {
            $(document).trigger('checkformbutton');
        }
    });

    // select credit card from list
    $('[id$="ckoCreditCardList"]').on('change', function () {
        var cardUUID = $(this).val();
        localStorage.setItem("cardUUID", cardUUID);
        if (!cardUUID) { return; }
        
        if($('input[id$="ckoCreditCardList"]:checked').length > 0) {
            var saveCardWrapEl = $('input[id$="ckoCreditCardList"]:checked').parent();
            if (saveCardWrapEl.length > 0 && saveCardWrapEl.attr('id') !== undefined) {
                $('.cvv-wrapper').addClass('hide-error');
                var $cvEle = $('input[name*="cardPaymentForm_cvn"]')
                $cvEle.insertAfter('#'+saveCardWrapEl.attr('id')+' .cvv-wrapper label');
                $cvEle.removeClass('error').on('keyup', _.debounce(() => $cvEle.trigger('change'), 200)).focus();
                setTimeout(() => {
                    $('.cvv-wrapper').removeClass('hide-error').find('span.error').remove();
                }, 1000);
            }
            if($('.order--checkout__ccmethod').hasClass('toggle--active')){
                $('.order--checkout__ccmethod').removeClass('toggle--active');
            }
        }
    
        populateCreditCardForm(cardUUID);

        // remove server side error
        $('.required.error').removeClass('error');
        $('.error-message:not(.code-error--message)').remove();
        if ($errorForm) {
            $errorForm.hide();
        }
    });

    $('[id$="ckoCreditCardList"]:checked').trigger('change');

    $('#check-giftcert').on('click', function (e) {
        e.preventDefault();
        var $balance = $('.balance'),
            $giftCert = $('.order--checkout__giftcert'),
            $error = getBEErrorEl($giftCert);

        if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
            $giftCert.addClass('error');
            $error.html(Resources.GIFT_CERT_MISSING);
            $balance.html('');
            return;
        }
        
        resetGiftBalanceMessage();
        
        giftcard.checkBalance($giftCertCode.val(), function (data) {
            if($giftCert.hasClass('error')){
                $giftCert.removeClass('error');
            }
            if (!data || !data.giftCertificate) {
                $giftCert.addClass('error');
                $error.html(Resources.GIFT_CERT_INVALID);

                return;
            }
            $balance.html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance).removeClass('error').addClass('success');
        });
    });

    $addGiftCert.on('click', function (e) {
        var code = $giftCertCode.val(),
            options = {
                type: 'giftcert',
                missingError: Resources.GIFT_CERT_MISSING,
                code: code,
                controller: Urls.redeemGiftCert,
                params: { giftCertCode: code, format: 'ajax' },
            };
        resetGiftBalanceMessage();
        processPromoEntry(e, options,"giftcert");
    });

    initCouponAction('billing');

    // trigger events on enter
    $couponCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addCoupon.click();
        }
    });
    $giftCertCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.click();
        }
    });

    $usedASavedCardClean.on('click', function () {
        if ($('input[id$="-ckoCreditCardList"]:checked')) {
            $('input[id$="-ckoCreditCardList"]:checked').prop('checked', false);
            cleanCardForm();
        } 
    });
    $unclickAddress.on('click', function () {
        if ($('input[name$="_addressList"]:checked')) {
            $('input[name$="_addressList"]:checked').prop('checked', false);
            $('[id$="_unsavedAddressBook"]').prop('checked', true);
            formPrepare.validateForm();
        }
        $('input[name$="_addressList"]:checked').prop('checked', false);
        $('input[name$="_saveBillingAddress"]').val(1);
        $('.js-edit').addClass('hidden');
        $('.custom-address, .saved-address').addClass('active');
    });
    $resetValidation.on('click', function () {
             $('input[id$="-ckoCreditCardList"]:checked').prop('checked', false)
         	cleanCardForm();
        if ($errorForm) {
            $errorForm.hide();
            
        }
       
        $('form[id$="billing"]').validate().resetForm();
    });
   
    
    $('.giftcertificate-remove').on('click',function(e) {
        setPromoSession('giftcert');
        var $closestForm = $(this).closest('form');
        storeFormData($closestForm);
    });
    
    disableButtonAfterSubmit();
    detectEditChanges();
    detectPhoneChanges();

    
    $(document).ready(function () {
        var limitInterval = 0;
        var billingFormInterval = setInterval(function(){
            var formErrors = $('.form-row.error');
            var promoItemEl = getPromoItemEl();
            if(formErrors.length > 0 || promoItemEl || limitInterval > 9){
                clearInterval(billingFormInterval);
                scrollToErrorForm();
            }
            limitInterval += 1;
        }, 70); 
    });
    
    $(document).on('checkoutPaymentSelection', function () {
        formPrepare.validateForm();
    });
     $(document).on('change','#selectedPaymentOption', function () {
        formPrepare.validateForm();
        shipping.updateSummary($(this).val()).then(()=>{
            toggleSummaryMobileView();
            initCouponAction('billing');
            checkIfFooterReachedScreen();
            hideStickyOnInput();
            expandSticky();
            updateGiftCertRemainingBalance();
            if($(this).val() === 'DW_COD') {
                $(document).trigger('checkformbutton');
            }
        });
    });
    
	
};
function updateGiftCertRemainingBalance(){
   var balanceText =  $('.order-value').text();
   $('.remainingAmount').html(balanceText);
}
exports.processPromoEntry = processPromoEntry;
exports.initCouponAction = initCouponAction;
exports.toggleSummaryMobileView = toggleSummaryMobileView;
function initCouponAction(page)
{
    $('#add-coupon').on('click', function (e) {
       var couponCodeObj = $('input[name$="_couponCode"]');
    	if(couponCodeObj.length > 0) {
    		if(couponCodeObj.val().trim() == '') {
    			e.preventDefault();
    			couponCodeObj.addClass('error');
    			return;
    		} else {
    			couponCodeObj.removeClass('error');
    		}
    	}
    	
        var code = couponCodeObj.val(),
            options = {
                type: 'coupon',
                missingError: Resources.COUPON_CODE_MISSING,
                code: code,
                controller: Urls.addCoupon,
                params: { couponCode: code, format: 'ajax' },
                operation:'addCoupon'
            };

        processPromoEntry(e, options,"coupon", page);
        
    });
    
    $('.remove-coupon').on('click', function (e) {
    	var code=$(this).attr("data-code"),
             options = {
                type: 'coupon',
                code: code,
                controller: Urls.deleteCoupon,
                params: { couponCode: code, format: 'ajax' },
                operation:'removeCoupon'
            };

        processPromoEntry(e, options,"coupon", page);
    });
}

function resetPaymentMethods()
{
    $('.converted').attr('hidden', 'true');
    $('input[name$="_paypalIsChecked"]').prop('checked', false);
    $('input[name$="_paypalIsChecked"]').val('false');
    if($('input[name$="apm_list"]').length > 0) {
        $('input[name$="apm_list"]').prop('checked', false);
    }
    
}

function resetAPMPaymentMethod()
{
    var el = $('input[name$="apm_list"]');
    if(el.length > 0) {
        var isChecked = $('input[name$="apm_list"]:checked');
        if(isChecked.length<=0) {
            el.first().prop('checked', true);
             $('.cko-apm-accordion').trigger('click');
        }
    }
}
function resetGiftBalanceMessage()
{
    var el = $('form[id$="_billing"] .balance');
    if(el.length >0) {
        el.html('');
    }
}
$(document).ready(function () {
	var isCouponApplied = localStorage.getItem("isCouponApplied");
	if(isCouponApplied == 'true'){
		var uuid= localStorage.getItem("cardUUID");
		if(uuid != "" && uuid != null){
			$('input[value="' + uuid + '"]').prop('checked', true);
		}
	}
	localStorage.setItem("isCouponApplied",false);
	localStorage.setItem("cardUUID","");
});

window.addEventListener('load', function () {
	if(isFormElFound === false) {
		scrollToErrorForm();
	}
	addressUtil.initGovernateEvents();
	
	$('.positivenumber').on('input',function(e) {
        this.value = this.value.replace(/\D/g,'');
    });
    formPrepare.validateForm();
    initPaymentmethodSelection();
})
function initPaymentmethodSelection(){
    var paymentElement = $('#selectedPaymentOption');
    if(paymentElement.length == 1 && paymentElement.val()=='DW_COD'){
        paymentElement.trigger('change');
    }
}
function scrollToErrorForm()
{
	var formErrors = $('.form-row.error,.billing-error');
	var scrollToTopEl = 50;
	isFormElFound = true;
    if(window.innerWidth < breakpoints.mobile) {
        scrollToTopEl = 80;
    } 
	if(formErrors.length > 0) {
		$('body, html').animate({
			scrollTop: $(formErrors[0]).offset().top-scrollToTopEl 
		}, 0);
	} else {
         var itemEl = getPromoItemEl();
	     if(getPromoSession()) {
             if (itemEl && itemEl.length > 0 && !itemEl.hasClass('order--checkout__giftcert')) {
                 $('body, html').animate({
                     scrollTop: itemEl.offset().top - scrollToTopEl
                 }, 0);
             }
             resetPromoSession();
         }
	}
}
function setPromoSession(type)
{
    localStorage.setItem("promoAppliedItem",type);
}

function getPromoSession()
{
    return localStorage.getItem("promoAppliedItem");
}

function resetPromoSession()
{
    if(getPromoSession()) {
        localStorage.removeItem("promoAppliedItem");
    }
}

function getPromoItemEl()
{
    if(getPromoSession()) {
        var item = getPromoSession();
	    if(item) {
	        var itemEl = $('.order--checkout__'+item).length > 0?$('.order--checkout__'+item):$('.'+item);
            if(itemEl && itemEl.length > 0 ) {
                return itemEl;
            }
        }
    }
    
    return false;
}

function toggleBackToSavedCards() {
    $('.saved-card-layout label').on('click', function () {
        if ($('.js-clean-form').first().parent().hasClass('toggle--active')) {
            $('.js-clean-form').trigger('click');
        }
    })
}

function clearAddressForm() {
    $(':input','.custom-address.billing-page, .order--checkout__form__section.no-saved.billing-page')
    .not(':button, :submit, :reset, :hidden,.country-selection-option')
    .val('')
    .prop('checked', false)
    .prop('selected', false);
    $('.custom-address .selectric-wrapper select').not('.country').prop('selectedIndex', 0).selectric('refresh');
    $('select.select2-option').val('').trigger('change').parents('.field-wrapper').siblings('.error').remove();
}

function toggleBillingAndShippingAddress() {
    var $addressPreview = $('.address-preview');
    var $guestAddress = $('.guest-address');
    var $savedAddress = $('.saved-address');
    var $customAddress = $('.custom-address');
    var $addressFieldWoSaved = $('.order--checkout__form__section.no-saved');

    const taskForGuest = () => {
        if (!$addressPreview.hasClass('hidden') || !$guestAddress.hasClass('hidden')) {
            $addressPreview.addClass('hidden');
            $guestAddress.addClass('hidden');
        } else if($addressPreview.hasClass('hidden') && $guestAddress.hasClass('hidden')) {
            $addressPreview.removeClass('hidden');
        }
    }
    function taskForUser() {
        if ($savedAddress.length == 0 && $addressFieldWoSaved.length) {
            if ($addressPreview.hasClass('hidden') && $addressFieldWoSaved.hasClass('hidden')) {
                $addressPreview.removeClass('hidden');
            } else if (!$addressPreview.hasClass('hidden') || !$addressFieldWoSaved.hasClass('hidden')) {
                $addressPreview.addClass('hidden');
                $addressFieldWoSaved.addClass('hidden');
            }
        }
        else if (!$addressPreview.hasClass('hidden') || !$savedAddress.hasClass('hidden')) {
            $addressPreview.addClass('hidden');
            $savedAddress.addClass('hidden');
            $customAddress.addClass('hidden');
        } else if($addressPreview.hasClass('hidden') && $savedAddress.hasClass('hidden')) {
            $addressPreview.removeClass('hidden');
        }
    }

    $('#shippingBillingSame').on('change', function () {
        if ($guestAddress.length) {
            taskForGuest();
        } else if ($savedAddress.length || $addressFieldWoSaved.length) {
            taskForUser();
        }
        if($(this).prop('checked')){ // If Shipping Same as Billing , Copy Shipping address to BIlling
            var selectorEl = $('select#countrySelectorList :selected');
            var currentCountry = selectorEl.length > 0 ? selectorEl.data('country'):false;
            if(!currentCountry) {
                currentCountry  = readCookie('preferredCountry');
            }
            if(currentCountry) {
                var country = currentCountry.toLowerCase();
                if (country) {
                    var $form = $('.billing-address-form-wrapper');
                    dynamicAddress.getAddressFields(country, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm,fillBillingAddressFields.bind($form));

                }
            }
        }
    });

    $addressPreview.on('click', '.change-address', () => {
        $addressPreview.addClass('hidden');
        if ($guestAddress.length) {
            setTimeout(() => {
                clearAddressForm();
            }, 0);
            $guestAddress.removeClass('hidden');
        } else if ($savedAddress.length) {
            $savedAddress.removeClass('hidden');
            if ($('input[id$="_unsavedAddressBook"]').prop('checked')) {
                $('.js-use-different').addClass('hidden');
                $('.custom-address').removeClass('hidden');
            } else {
                $('.js-use-different').removeClass('hidden');
            }
        } else if ($addressFieldWoSaved.length) {
            setTimeout(() => {
                clearAddressForm();
            }, 0);
            $addressFieldWoSaved.removeClass('hidden');
        }
    });

    $('.js-use-different').on('click', function () {
        $customAddress.removeClass('hidden');
        clearAddressForm();
        $(this).addClass('hidden');
    });

    $('.js-us-saved-address.billing-page').on('click', function () {
        $customAddress.addClass('hidden');
        $('.js-use-different').removeClass('hidden');
        $('.js-edit').removeClass('hidden');
        $('.custom-address, .saved-address').removeClass('active');
        setTimeout(() => {
            addressToEdit && addressToEdit.trigger('click');
            addressToEdit = null;
        }, 0);
    });
    const validateFields = (adrsType) => {
        var isValid = false;
        $(adrsType).find('input').each((i, ele) => {
            isValid = $(ele).valid();
            return isValid;
        });
        return isValid;
    }
    $('.address-actions .btn-save').on('click', function () {
        let name = '', address = '', adrsType='.guest-address';
        if ($(this).hasClass('is-authed')) {
            adrsType = '.custom-address';
            if ($('.custom-address').length == 0) {
                adrsType = '.address-fieldset.no-saved';
            }
        }
        if (!validateFields(adrsType)) {
            return;
        }
        name = $(`${adrsType} .field-firstname`).val() + ' ' + $(`${adrsType} .field-lastname`).val();
        address= jQuery.makeArray($(`${adrsType} .field-addressline`).find('input.input-text,.input-select').map((index, it) => $(it).val().toString()));
        address = address.filter(function (el) {
		  return el != "";
		});
        $('.address-preview .address-preview--fullname').html(name);
        $('.address-preview .address-preview--addressline').html(address.join(', '));
        $guestAddress.addClass('hidden');
        $customAddress.addClass('hidden');
        $(adrsType).addClass('hidden');
        $savedAddress.addClass('hidden');
        $addressPreview.removeClass('hidden');
    });
    
    $('.address-actions .btn-cancel').on('click', function() {
        $guestAddress.addClass('hidden');
        $addressFieldWoSaved.addClass('hidden');
        if (!$(this).hasClass('is-authed') || ($savedAddress.length == 0 && $addressFieldWoSaved.length)) {
            $addressPreview.removeClass('hidden');
            var countrySelector = document.querySelector('[id$="_country"]');
            if(countrySelector) {
                var country = countrySelector.value;
                if (country) {
                    var $form = $('.billing-address-form-wrapper');
                    dynamicAddress.getAddressFields(country, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm,fillBillingAddressFields.bind($form));

                }
            }
        }
    });
    function fillBillingAddressFields(){
        var $form = this;
        var url = window.Urls.getShippingAddress;
        ajax.getJson({
            url: url,
            callback: function (data) {
                util.fillAddressFields( data.address, $form);
                updateAddressPlaceHolder();
            }
        });

    }
    function updateAddressPlaceHolder(){
        let name = '', address = '', adrsType='.guest-address';
        if ($(this).hasClass('is-authed')) {
            adrsType = '.custom-address';
        }
        if (!validateFields(adrsType)) {
            return;
        }
        name = $(`${adrsType} .field-firstname`).val() + ' ' + $(`${adrsType} .field-lastname`).val();
        address= jQuery.makeArray($(`${adrsType} .field-addressline`).find('input.input-text,.input-select').map((index, it) => $(it).val().toString()));
        address = address.filter(function (el) {
            return el != "";
        });
        $('.address-preview .address-preview--fullname').html(name);
        $('.address-preview .address-preview--addressline').html(address.join(', '));
    }

    $('.saved-address-preview').on('click', function () {
        var isChecked = false;
        $('.saved-address-preview').find('input').each(function (i,ele) {
            isChecked = $(ele).prop('checked');
            return !isChecked;
        });
        if (!isChecked) {
            $('.js-us-saved-address').trigger('click');
            setTimeout(() => {
                $(this).find('input').prop('checked', true);
            }, 0);
        }
    });
}

function toggleSummaryMobileView() {
    $('.showsum_title').on('click', function () {
        $(this).toggleClass('toggle--active')
        let rows = $('.order-totals-table > .order__summary__row');
        let freeShipping = $('.free_shipping');
        if (rows.css('display')=='none') {
            rows.css('display', 'flex');
        } else {
            rows.hide();
        }
        if (freeShipping.length && freeShipping.css('display')=='none') {
            freeShipping.css('display', 'block');
        } else {
            freeShipping.hide();
        }
    });
}

function heightAdjustOnCartOpen() {
    $('#mini-cart-toggler').on('click', function () {
        let heightToSet = $('#secondary').height();
        $('#checkoutSpacer.billing-page').height(heightToSet - 40).toggleClass('hidden');
    })
}

function triggerMobBack() {
    $('.address-back.billing').on('click', function () {
        if($('.js-us-saved-address').length>0)
            $('.js-us-saved-address').first().trigger('click');
        else
            $('.btn-cancel').first().trigger('click');
    });
}

function scrollHere(element) {
    $([document.documentElement, document.body]).animate({
        scrollTop: element.offset().top
    },500);
}

function validatePhone() {
    const replaceTexts = (ele) => {
        ele.val(ele.val().replace(/[^0-9 ]/gm, ''));
    }
    $("input[id$='addressFields_phone']").on('input', function () {
        replaceTexts($(this));
    }).on('paste', function () {
        replaceTexts($(this));
    });
}

function checkIfFooterReachedScreen() {
    if ($('.pt_checkout').length <= 0) {
        return;
    }
    let isEventActive = false;
    
    let elToHide = $('.checkout-order-totals.mini-view,.form-row-button,#submit-order,.payment-modes-wrapper,#applePayDummyBtn');
    const doShowOrHide = () => {
        elToHide = $('.checkout-order-totals.mini-view,.form-row-button,#submit-order,.payment-modes-wrapper,#applePayDummyBtn');
        let screenOffset = $(window).scrollTop();
        if (screenOffset + $(window).height() > $(document).height() - 75) {
            !$('.order__summary__coupon__entry').hasClass('toggle--active') && elToHide.hide(500);
        } else if (elToHide.css('display') === 'none') {
            elToHide.show(500);
        }
    };
    const bindScrollEvent = () => {
        $(window).on('scroll.webScrollEvent', doShowOrHide);
        isEventActive = true;
    };
    const unBindScrollEvent = () => {
        $(window).off('scroll.webScrollEvent');
        isEventActive = false;
    };
    $(window).on('resize', () => {
        if ($(window).width() <= 767) {
            !isEventActive && bindScrollEvent();
        } else {
            isEventActive && unBindScrollEvent();
            elToHide.show();
        }
    });
    if ($(window).width() <= 767) {
        doShowOrHide();
    }
}

function hideStickyOnInput() {
    if ($('.pt_checkout').length <= 0) {
        return;
    }
    let inputs = $('input[type=text], input[type=password], input[type=email], input[type=tel], textarea').not(".login-modal--input input, input[id$='_couponCode']");
    let isEventActive = false;
    const minimize = () => {
        $('.mini-view, .form-row-button .button, .order--checkout__footer.input-list .button, .payment-modes-wrapper').addClass('minimize');
    };
    const bindEvent = () => {
        inputs.on('focus.inputFocusEvent', function () {
            minimize();
            $([document.documentElement, document.body]).animate({
                scrollTop: $(this).offset().top - 100
            }, 200);
        });
        $('body').on('click.select2FocusEvent', '.select2.select2-container', minimize);
        isEventActive = true;
    }
    const unbindEvent = () => {
        inputs.off('focus.inputFocusEvent');
        $('body').off('focus.select2FocusEvent');
        isEventActive = false;
    }
    const bindOrUnbindEvent = () => {
        if ($(window).width() <= 767) {
            !isEventActive && bindEvent();
        } else {
            isEventActive && unbindEvent();
        }
    }
    bindOrUnbindEvent();
    $(window).on('resize', bindOrUnbindEvent);
}

function expandSticky() {
    const unhide = () => {
        $('.mini-view, .form-row-button .button,.order--checkout__footer.input-list .button, .payment-modes-wrapper').removeClass('minimize');
    };
    $('.form-row-button .button, .order--checkout__footer.input-list .button').on('enabled', unhide);
    $('.unhide-arrow').on('click', unhide);
}

function hideAddressSuggestionOnScroll() {
    $('.address-fieldset').on('scroll', () => {
        let $container = $('.pac-container');
        if ($container.is(':visible')) {
            $container.css('display', 'none');
        }
    }).on('click','.pac-target-input', () => {
        let $container = $('.pac-container');
        let elementOffset = $('.pac-target-input').offset().top;
        if ($container.is(':parent') && !$container.is(':visible')) {
            $container.css({
                'display': 'block',
                'top': elementOffset + 50
            });

        }
    });
}

function billingGAEvents() {
	var user = dataLayer.find(o => o.user != null).user;
    $('.gift-promo-toggle').find('.order--checkout__form__title').on('click', function (e) {
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'checkout_page',
    	    'eventAction': 'checkout_redeem_gift_card_click',
    	    'eventLabel': 'checkout redeem gift card click',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Checkout Page',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })
    $('#check-giftcert').on('click', function (e) {
    	var giftCert = $('#dwfrm_billing_giftCertCode').val();
    	if (giftCert != '') {
        	dataLayer.push({
        	    'event': 'custom_event',
        	    'eventCategory': 'checkout_page',
        	    'eventAction': 'chk_redeem_gift_card_check_balance',
        	    'eventLabel': 'checkout redeem gift card check balance click',
        	    'country': window.GlobalAttributes.COUNTRY,
        	    'language': window.GlobalAttributes.LANGUAGE,
        	    'screenName' : 'Checkout Page',
        	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
        	    'userId': user.user_id != '' ? user.user_id : ''
        	});
    	}
    })
    $("#coupon-form-summary .promo_title").on('click', function (e) {
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'checkout_page',
    	    'eventAction': 'checkout_promo_code_click',
    	    'eventLabel': 'checkout promo code click',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Checkout Page',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })
}

$(document).ready(function () {

    const setInputReadOnly = () => {
        $('.select2-option').select2({
            sorter: function(data) {
                var defOption = false;
                if(data.length > 0) {
                    defOption = (data.splice(data.findIndex(e => e.id === ""),1));
                    if(defOption && defOption.length > 0) {
                        defOption = defOption[0];
                    } else {
                        defOption = false;
                    }
                }
                var optionData = data.sort(function(a, b) {
                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                });
                if(defOption) {
                    optionData.unshift(defOption);
                }
                return optionData;
            }
        }).on('select2:open', function (e) {
            $('.select2-search input').attr('readonly', true).blur();

            $('.select2-search input').on('click', function () {
                $(this).attr('readonly', false).focus();
            });
        });
    };

    if (!navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
        setInputReadOnly();
        $('select.country-selection-option').on('change', function () {
            setTimeout(setInputReadOnly, 1000);
        });
    }

    if(typeof zE !== 'undefined' && !!zE) {
        zE(function() {
           zE.hide();
        });
    }

    toggleBillingAndShippingAddress();
    toggleBackToSavedCards();
    toggleSummaryMobileView();
    heightAdjustOnCartOpen();
    triggerMobBack();
    validatePhone();
    checkIfFooterReachedScreen();
    hideStickyOnInput();
    expandSticky();
    hideAddressSuggestionOnScroll();
    billingGAEvents();
    $(document).trigger('initinfobip');
    $('form[id*="billing"] input[type="submit"]').on('enabled',function() {
         $(document).trigger('checkformbutton');
    });
});




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/billing.js